import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import InputCurrency from 'Components/Atoms/InputCurrency/InputCurrency';

export default function RHFInputCurrency({ name, onChange, ...other }) {
    const { control, clearErrors } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                useEffect(() => {
                    if (field.value && field.value !== '' && error) {
                        clearErrors(name);
                    }
                }, [field.value, error, clearErrors, name]);

                const handleChange = (value) => {
                    field.onChange(value);
                    if (onChange) {
                        onChange(value);
                    }
                };
                return <InputCurrency {...field} error={error?.message} {...other} onChange={handleChange} />;
            }}
        />
    );
}

RHFInputCurrency.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
};
